export default __webpack_public_path__ + "graphics/wall.0656f47c.jpg";